import routeNames from './route-names'
import BaseRouterView from '@/components/base/BaseRouterView'

const ScheduledBundles = () => import(/* webpackChunkName: "bundles" */'@/views/scheduled-report/bundle/ScheduledBundles')
const ScheduledReportTabs = () => import(/* webpackChunkName: "bundles" */'@/views/scheduled-report/ScheduledReportTabs')
const ManageScheduledReport = () => import(/* webpackChunkName: "bundles" */'@/views/scheduled-report/ManageScheduledReport')
const RemoveScheduledReports = () => import(/* webpackChunkName: "bundles" */'@/views/scheduled-report/RemoveScheduledReports')


export default {
    path: '/tools/scheduled-reports',
    alias: '/scheduled-reports',
    component: BaseRouterView,
    children: [
        {
            path: '/',
            component: ScheduledReportTabs,
            children: [
                {
                    path: 'bundles',
                    name: routeNames.SCHEDULED_BUNDLES,
                    meta: {title: 'Bundles'},
                    component: ScheduledBundles,
                    children: [
                        {
                            path: 'create',
                            name: routeNames.SCHEDULED_BUNDLE_CREATE,
                            meta: {title: 'Create ScheduledReport'},
                            component: ManageScheduledReport
                        },
                        {
                            path: 'update/:reportUuid',
                            name: routeNames.SCHEDULED_BUNDLE_UPDATE,
                            meta: {title: 'Update ScheduledReport'},
                            props: (route) => ({
                                reportUuid: route.params.reportUuid
                            }),
                            component: ManageScheduledReport
                        },
                        {
                            path: 'remove/multiple',
                            name: routeNames.SCHEDULED_BUNDLE_BULK_REMOVE,
                            meta: {title: 'Remove Scheduled Reports'},
                            props: (route) => ({
                                ...route.params,
                                bulk: true
                            }),
                            component: RemoveScheduledReports
                        },
                        {
                            path: 'remove/:reportUuid',
                            name: routeNames.SCHEDULED_BUNDLE_REMOVE,
                            meta: {title: 'Remove Scheduled Report'},
                            props: (route) => ({
                                reportUuid: route.params.reportUuid
                            }),
                            component: RemoveScheduledReports
                        }
                    ]
                }
            ]
        }
    ]
}
